import Player from '@vimeo/player';
import { useEffect, useRef, useState } from 'react';
import { extractVimeoId } from '../../../network/vimeo_network_service/Vimeo_api_callback';

const VimeoVideoPlayer = ({ multimediaData }) => {

    const videoRef = useRef(null);
    const [player, setPlayer] = useState(null);
    const [duration, setDuration] = useState(0);
    const [selectedMarker, setSelectedMarker] = useState(null);

    // Start with your default markers
    const [markers, setMarkers] = useState([
        // { time: 5, text: "Intro scene" },
        // { time: 15, text: "Action starts" },
        // { time: 29, text: "Climax" }
    ]);

    // Initialize Vimeo Player
    useEffect(() => {
        let videoId = null;

        if (multimediaData?.url) {
            videoId = multimediaData?.url?.split("/").pop();
        }
        else if (multimediaData?.videoUrl) {
            // Extract numeric ID from the api URL
            videoId = extractVimeoId(multimediaData?.videoUrl);
        } 
        // else if (multimediaData?.progressiveLink) {
        //     // Extract ID from progressive link → find first numeric chunk
        //     const match = multimediaData.progressiveLink.match(/\/(\d+)\//);
        //     videoId = match ? match[1] : null;
        // }

        if (!videoId) {
            console.error("❌ No valid Vimeo ID found");
            return;
        }

        console.log("🎬 Using Vimeo videoId:", videoId);

        const newPlayer = new Player(videoRef.current, {
            id: videoId,   // ✅ Must be numeric Vimeo video ID
            responsive: true,
            //width: 640
        });


        newPlayer?.ready().then(() => {
            newPlayer?.getDuration().then((dur) => setDuration(dur));
        });

        setPlayer(newPlayer);

        return () => {
            newPlayer?.unload();
        };
    }, [multimediaData]);

    //console.log("duration : ",duration)

    // Function to add marker
    const addMarker = async (description) => {
        if (!player) return;

        const currentTime = await player?.getCurrentTime();

        setMarkers((prev) => [
            ...prev,
            { time: Math.floor(currentTime), text: description }
        ]);
    };

    const handleMarkerClick = (marker) => {
        if (!player) return;
        player?.setCurrentTime(marker?.time).then(() => {
            player?.pause();
            setSelectedMarker(marker);
        });
    };

    return (
        <div style={{ position: "relative", width: "640px", margin: "auto", }}>
            {/* Vimeo player container */}
            <div ref={videoRef} />

            {/* Marker track */}
            <div
                style={{
                    position: "relative",
                    height: "8px",
                    background: "#ccc",
                    marginTop: "4px"
                }}
            >
                {markers?.map((marker, index) => (
                    <div
                        key={index}
                        title={`${marker?.text} (${marker?.time}s)`}
                        style={{
                            position: "absolute",
                            bottom: 0,
                            left: `${(marker?.time / duration) * 100}%`,
                            transform: "translateX(-50%)",
                            width: "4px",
                            height: "8px",
                            background: "red",
                            cursor: "pointer"
                        }}
                        onClick={() => handleMarkerClick(marker)}
                    />
                ))}
            </div>

            {/* Marker description popup */}
            {selectedMarker && (
                <div
                    style={{
                        marginTop: "10px",
                        padding: "8px",
                        border: "1px solid #ccc",
                        background: "#f9f9f9"
                    }}
                >
                    <strong>Marker:</strong> {selectedMarker?.text} (
                    {selectedMarker?.time}s)
                </div>
            )}

            {/* Button */}
            <div className="marker-button-wrapper" style={{ marginTop: "10px", }}>
                {/* <button
                    className="add-marker-btn"
                    onClick={() =>
                        addMarker(prompt("Enter marker description:") || "No description")
                    }
                >
                    Add Marker
                </button> */}
            </div>
        </div>
    );
}

export default VimeoVideoPlayer
